import { useEffect, useRef } from "react"
import mapboxgl from "mapbox-gl"
import { Box } from "@mui/material"
import { mapboxToken, mapStyle } from "../../utils/map"
import theme from "../../theme"

type InteractiveMapProps = {
  latitude?: number
  longitude?: number
}

export const VehiclePositionMap = ({ latitude, longitude }: InteractiveMapProps) => {
  const mapContainer = useRef<HTMLDivElement | null>(null)
  const mapRef = useRef<mapboxgl.Map | null>(null)
  const markerRef = useRef<mapboxgl.Marker | null>(null)

  useEffect(() => {
    if (!mapContainer.current || mapRef.current) return
    if (latitude == null || longitude == null) return

    mapboxgl.accessToken = mapboxToken

    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: `mapbox://styles/seerefine/${mapStyle}`,
      center: [longitude, latitude],
      zoom: 15,
    })

    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }))

    const marker = new mapboxgl.Marker({ color: "red" })
      .setLngLat([longitude, latitude])
      .addTo(map)

    mapRef.current = map
    markerRef.current = marker

    return () => {
      markerRef.current?.remove()
      mapRef.current?.remove()
      markerRef.current = null
      mapRef.current = null
    }
  }, [latitude, longitude])

  useEffect(() => {
    if (!mapRef.current || !markerRef.current) return
    if (latitude == null || longitude == null) return

    markerRef.current.setLngLat([longitude, latitude])

    mapRef.current.easeTo({
      center: [longitude, latitude],
      duration: 500,
    })
  }, [latitude, longitude])

  if (latitude == null || longitude == null) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.colors.lightGrey,
          color: theme.colors.grey,
          fontFamily: "Futura",
          fontSize: 14,
        }}
      >
        No vehicle position available
      </Box>
    )
  }

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box ref={mapContainer} sx={{ width: "100%", height: "100%" }} />
    </Box>
  )
} 
